/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';

type Props = {
  children: any,
  darkMode: boolean,
  status: 'done' | 'not done' | 'pending'
};

const Outer = styled.span(({ darkMode, theme }) => ({
  color: darkMode ? theme.color.basis5 : theme.color.invertableBasis5,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  textAlign: 'center',
  [theme.mediaQuery.desktopAndUp]: {
    flexDirection: 'row'
  }
}));

const Inner = styled.span(({ darkMode, highlight, theme }) =>
  highlight
    ? {
        color: darkMode ? theme.color.basis6 : theme.color.invertableBasis6
      }
    : {}
);

const Prefix = styled.span(({ color, theme }) => ({
  color: color ? theme.color[color] : 'inherit',
  margin: '0 auto',
  [theme.mediaQuery.desktopAndUp]: {
    width: '1.5em'
  }
}));

const VerificationSummaryText: React.FC = ({ children, darkMode, status }: Props) => {
  let color = 'success';

  if (status === 'not done') {
    color = 'danger';
  } else if (status === 'pending') {
    color = 'warning';
  }
  return (
    <Outer darkMode={darkMode}>
      <Prefix
        color={color}
        className={status === 'done' ? 'ion-checkmark-circled' : 'ion-close-circled'}
      />
      <Inner darkMode={darkMode} highlight={status === 'done'}>
        {children}
        {status === 'pending' && ' (Pending)'}
      </Inner>
    </Outer>
  );
};

const mapStateToProps = state => ({
  darkMode: state.settings.darkMode
});

export default connect(mapStateToProps)(VerificationSummaryText);
